var host = window.location.hostname.replace(/^www\./, "").toLowerCase();
var sub = host.split(".")[0]; // ye mapping ke liye rahega

fetch(PARTNERS_URL)
  .then(function (r) { return r.json(); })
  .then(function (map) {
    var email = map[sub] || "";

    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var attrs = cart.attributes || {};

        if (
          attrs.partner_email === email &&
          attrs.partner_subdomain === host   
        ) {
          return;
        }

        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: {
              partner_subdomain: host,   
              partner_email: email   
            }
          })
        });
      });
  });